<div [appStoryblok]="_editable">
  @defer {
  <app-carousel [options]="options">
    <div class="slide my-auto" *ngFor="let slide of slides">
      <div class="gap px-5">
        <div class="text-center quote">{{ slide.content }}</div>
        <div class="text-center stars">
          <svg
            *ngFor="let start of [1, 2, 3, 4, 5]"
            width="28"
            height="26"
            viewBox="0 0 28 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 0.390137L17.9664 8.93089L27.3148 10.0639L20.4177 16.4754L22.229 25.7164L14 21.1381L5.77101 25.7164L7.58227 16.4754L0.685208 10.0639L10.0336 8.93089L14 0.390137Z"
              fill="#DE178F"
            />
          </svg>
        </div>
        <div class="author text-center">
          <svg
            class="me-3"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 0.390137C4.97005 0.390137 0.5 4.86018 0.5 10.3901C0.5 15.9201 4.97005 20.3901 10.5 20.3901C16.03 20.3901 20.5 15.9201 20.5 10.3901C20.5 4.86018 16.03 0.390137 10.5 0.390137ZM9.5553 14.9063C9.32489 15.1367 9.0023 15.2749 8.65668 15.2749C8.31106 15.2749 7.98848 15.1367 7.75806 14.9063L4.18664 11.3348L5.98387 9.5376L8.65668 12.2104L15.0161 5.85097L16.8134 7.6482L9.5553 14.9063Z"
              fill="black"
            />
          </svg>
          {{ slide.author }}
        </div>
      </div>
    </div>
  </app-carousel>
  } @placeholder {
  <div></div>
  }
</div>
